// scroll down to the next section

const scrollDown = document.querySelector('.js-scroll-down');
if(scrollDown) {
  scrollDown.addEventListener('click', (e) => {
    e.preventDefault();
    e.target.closest('.shopify-section').nextSibling.scrollIntoView({
      behavior: 'smooth'
    });
  });
}

